import type { ButtonHTMLAttributes } from 'react'

type Variant = 'primary' | 'secondary' | 'danger' | 'ghost'

const variants: Record<Variant, string> = {
  primary:
    'bg-gradient-to-b from-brand-500 to-brand-700 text-white shadow-sm shadow-brand-700/30 ' +
    'hover:from-brand-600 hover:to-brand-800 hover:shadow-md hover:shadow-brand-700/30 ' +
    'active:from-brand-700 active:to-brand-900 ' +
    'focus-visible:outline-brand-600',
  secondary:
    'bg-white text-slate-700 border border-slate-300 shadow-sm ' +
    'hover:bg-slate-50 hover:border-slate-400 hover:text-slate-900 ' +
    'active:bg-slate-100 ' +
    'focus-visible:outline-slate-400',
  danger:
    'bg-gradient-to-b from-red-500 to-red-700 text-white shadow-sm shadow-red-700/25 ' +
    'hover:from-red-600 hover:to-red-800 hover:shadow-md hover:shadow-red-700/30 ' +
    'active:from-red-700 active:to-red-900 ' +
    'focus-visible:outline-red-600',
  ghost:
    'text-slate-600 hover:bg-slate-100 hover:text-slate-900 active:bg-slate-200 focus-visible:outline-slate-400',
}

interface ButtonProps extends ButtonHTMLAttributes<HTMLButtonElement> {
  variant?: Variant
  size?: 'sm' | 'md'
}

export function Button({
  variant = 'primary',
  size = 'md',
  className = '',
  type = 'button',
  ...props
}: ButtonProps) {
  return (
    <button
      type={type}
      className={`inline-flex items-center justify-center gap-1.5 rounded-lg font-medium transition-all duration-150 active:scale-[0.97] focus-visible:outline-2 focus-visible:outline-offset-2 disabled:cursor-not-allowed disabled:opacity-50 disabled:active:scale-100 ${
        size === 'sm' ? 'px-2.5 py-1.5 text-xs' : 'px-4 py-2 text-sm'
      } ${variants[variant]} ${className}`}
      {...props}
    />
  )
}
